import React from 'react';
import PropTypes from 'prop-types';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import useStyles from './MultipleSelect.styled';

const menuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
  disableAutoFocusItem: true,
};

const MultipleSelect = ({
  id,
  item,
  options,
  selectedOptions,
  handleChange,
}) => {
  const classes = useStyles();
  return (
    <FormControl fullWidth>
      <Select
        multiple
        value={selectedOptions}
        id={`${item}-${id}-select`}
        onChange={handleChange}
        classes={{ root: classes.selectRoot }}
        variant="outlined"
        MenuProps={menuProps}
      >
        {options.map((el) => (
          <MenuItem value={el.value} className={classes.menuItem}>
            {el.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MultipleSelect.propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
  selectedOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ),
  handleChange: PropTypes.func.isRequired,
};

MultipleSelect.defaultProps = {
  selectedOptions: [],
};

export default MultipleSelect;
